import { Button, Divider, Header, List, Modal, Text } from '@wework/dieter-ui'
import Row from '../Common/Row'
import React from 'react'
import {
  getLastRead,
  getWhatsNew,
  setLastRead,
} from '../../utils/whatsnew-utils'

const renderList = listData => {
  return (
    <>
      <Text> {listData.title}</Text>
      <List items={listData.elements} bulleted />
    </>
  )
}

const renderElement = element => {
  switch (element.type) {
    case 'text':
      return <Text>{element.value}</Text>
    case 'markup':
      return <div dangerouslySetInnerHTML={{ __html: element.value }} />
    case 'list':
      return renderList(element.value)
    case 'media':
      return (
        <img src={element.value} style={{ width: '100%', marginTop: 24 }} />
      )
    default:
      return null
  }
}

export default function WhatsNew({ open, onClose }) {
  return (
    <Modal
      style={{ width: '40%' }}
      onClose={onClose}
      // onOpen={() => handler(true)}
      open={open}
    >
      <Modal.Header style={{ padding: 0 }}>
        <Row>
          <Header as="h3" style={{ margin: 0 }}>
            What’s new
          </Header>
          <Button basic onClick={onClose} icon="close" style={{}} />
        </Row>
      </Modal.Header>
      <Modal.Content scrolling>
        {getWhatsNew()?.map((newE, index) => {
          return (
            <React.Fragment key={index}>
              <Row style={{ marginBottom: 16, justifyContent: 'flex-start' }}>
                {newE.version > getLastRead() && (
                  <div
                    style={{
                      background: '#0077CC',
                      width: 12,
                      height: 12,
                      marginRight: 8,
                      borderRadius: 24,
                    }}
                  />
                )}
                <Text size="tiny" color="grey">
                  {newE.date}
                </Text>
              </Row>
              <div>
                <Header as="h5">{newE.title}</Header>
                {newE.elements.map((e, index) => {
                  return (
                    <React.Fragment key={index}>
                      {renderElement(e)}
                    </React.Fragment>
                  )
                })}
              </div>
              <Divider light />
            </React.Fragment>
          )
        })}
      </Modal.Content>
      <Modal.Actions style={{ textAlign: 'center' }}>
        <Text
          primary
          size="small"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setLastRead()
            onClose()
          }}
        >
          Mark as read
        </Text>
      </Modal.Actions>
    </Modal>
  )
}
